import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap'
import Loader from "../../Material/Loader"
import DatetimeRenderer from "../../Material/DatetimeRenderer"
import { CarInspectionPictures } from "./Queries"
import "./CarInspections.css"

export default function CarInspectionPicturesModal({ carConditionId, title, open, handleClose }) {
    const { data, loading, error } = useQuery(CarInspectionPictures, {
        variables: { carConditionId },
        fetchPolicy: "cache-and-network",
    })
    const [index, setIndex] = useState(0)

    const pictures = data?.carCondition?.carpicturesSet?.edges?.map(edge => edge.node) || []
    const picture = pictures[index]
    const hasPrev = index > 0
    const hasNext = index < pictures.length - 1

    // Arrow keys step through the pictures while the modal is open.
    useEffect(() => {
        const onKeyDown = (event) => {
            if (event.key === "ArrowLeft") setIndex(current => Math.max(current - 1, 0))
            if (event.key === "ArrowRight") setIndex(current => Math.min(current + 1, pictures.length - 1))
        }
        window.addEventListener("keydown", onKeyDown)
        return () => window.removeEventListener("keydown", onKeyDown)
    }, [pictures.length])

    return (
        <Modal isOpen={open} toggle={handleClose} size="xl" className="car-inspection-pictures-modal">
            {/* reactstrap 9 draws Bootstrap 5's icon-less btn-close; the app loads
                Bootstrap 4 CSS, so pass the Bootstrap 4 close button instead. */}
            <ModalHeader close={<button type="button" className="close" onClick={handleClose} aria-label="Close">&times;</button>}>{title}</ModalHeader>
            <ModalBody>
                {loading && !data ? <Loader /> :
                    error ? <p className="text-danger">Couldn't load pictures: {error.message}</p> :
                        !picture ? <p>No pictures were taken at this inspection.</p> :
                            <>
                                <div className="car-inspection-pictures-viewer">
                                    <div className="car-inspection-pictures-stage">
                                        <Button color="dark" className="car-inspection-pictures-nav" disabled={!hasPrev} onClick={() => setIndex(index - 1)} aria-label="Previous picture">
                                            <i className="fa fa-chevron-left" />
                                        </Button>
                                        <a href={picture.pictureUrl} target="_blank" rel="noopener noreferrer">
                                            <img className="car-inspection-pictures-image" src={picture.pictureUrl} alt={picture.pictureTypeDisplay} />
                                        </a>
                                        <Button color="dark" className="car-inspection-pictures-nav" disabled={!hasNext} onClick={() => setIndex(index + 1)} aria-label="Next picture">
                                            <i className="fa fa-chevron-right" />
                                        </Button>
                                    </div>
                                    <dl className="car-inspection-pictures-details">
                                        <dt>Picture</dt>
                                        <dd>{index + 1} of {pictures.length}</dd>
                                        <dt>Type</dt>
                                        <dd>{picture.pictureTypeDisplay || "--"}</dd>
                                        <dt>Description</dt>
                                        <dd>{picture.description || "--"}</dd>
                                        <dt>Date Added</dt>
                                        <dd><DatetimeRenderer datetime={picture.dateAdded} /></dd>
                                    </dl>
                                </div>
                                <div className="car-inspection-pictures-thumbnails">
                                    {pictures.map((thumbnail, i) =>
                                        <img
                                            key={thumbnail.id}
                                            src={thumbnail.pictureUrl}
                                            alt={thumbnail.pictureTypeDisplay}
                                            title={thumbnail.pictureTypeDisplay}
                                            className={"car-inspection-pictures-thumbnail" + (i === index ? " active" : "")}
                                            onClick={() => setIndex(i)}
                                        />
                                    )}
                                </div>
                            </>
                }
            </ModalBody>
        </Modal>
    )
}
